// mixpanel.js
import mixpanel from "mixpanel-browser";

// Initialize Mixpanel with your project token
const YOUR_MIXPANEL_PROJECT_TOKEN = "6679084d80c4a2fe46762ec01beec28c";
mixpanel.init(YOUR_MIXPANEL_PROJECT_TOKEN, {
  debug: process.env.REACT_APP_ENV !== "prod", // Enable debug mode in development
  //track_pageview: true, // Automatically track page views
  ignore_dnt: false,
  persistence: "cookie", // Store data in cookie
  stop_utm_persistence: true,
  // cross_subdomain_cookie : true,
  secure_cookie: true
  // api_host : "https://fundtap.co",
});

// Optional: Identify users (call this after user login)
export const identifyUser = (userId) => {
  mixpanel.identify(userId);
};

// Track custom events
export const trackEvent = (eventName, properties = {}) => {
  mixpanel.track(eventName, properties);
};

// Set user properties
export const setOnceUserProperties = (properties) => {
  mixpanel.people.set_once(properties);
};

// Set once user properties
export const setUserProperties = (properties) => {
  mixpanel.people.set(properties);
};

// Set user login count properties
export const userLoginCountProperties = (properties) => {
  mixpanel.people.increment(properties);
};

//reset mixpanel
export const reset = () => {
  mixpanel.reset();
};

export default mixpanel;
